const serviceNetworkSsoProviderConfig = {
  name: 'Service Network SSO Provider',
  endpoint: '/internal_admin/admin_kit/service_network_sso_providers',
  modelKey: 'service_network_sso_provider',
  titleField: 'service_network',

  columns: [
    { name: 'service_network', title: 'Service Network', type: 'link' },
    { name: 'provider_label', title: 'Provider' },
    { name: 'active', title: 'Active', type: 'boolean' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    {
      name: 'q[service_network_uuid_eq]',
      label: 'Service Network',
      options: (props) => props.serviceNetworks ?? [],
    },
    {
      name: 'q[provider_eq]',
      label: 'Provider',
      options: (props) => props.providers ?? [],
    },
    {
      name: 'q[active_eq]',
      label: 'Status',
      options: (props) => props.activeOptions ?? [],
    },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'service_network', label: 'Service Network' },
    { name: 'provider_label', label: 'Provider' },
    { name: 'active', label: 'Active', type: 'boolean' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'service_network_uuid',
        label: 'Service Network',
        type: 'select',
        options: (props) => props.serviceNetworks ?? [],
      },
      {
        name: 'provider',
        label: 'Provider',
        type: 'select',
        options: (props) => props.providers ?? [],
      },
      { name: 'active', label: 'Active', type: 'checkbox', defaultValue: true },
    ],
  },
};

export default serviceNetworkSsoProviderConfig;
